import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { THOUSAND_MOVES } from '../game/gameConfig';

function ThousandPerformanceStage({ onComplete }) {
  const [step, setStep] = useState(0);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [feedback, setFeedback] = useState('跟隨領拳者，同步起式');
  const stats = useRef({ hits: 0, bestCombo: 0, score: 0 });
  const completed = useRef(false);
  const current = THOUSAND_MOVES[step];

  useEffect(() => {
    if (!current && !completed.current) {
      completed.current = true;
      onComplete(stats.current);
      return undefined;
    }

    const timeout = window.setTimeout(() => {
      setCombo(0);
      setFeedback('節奏未合，重新守中');
      setStep((value) => value + 1);
    }, 1800);

    return () => window.clearTimeout(timeout);
  }, [current, onComplete]);

  const synchronise = (position) => {
    if (!current || position !== current.position) return;

    const nextCombo = combo + 1;
    const gain = 150 + nextCombo * 15;
    stats.current = {
      hits: stats.current.hits + 1,
      bestCombo: Math.max(stats.current.bestCombo, nextCombo),
      score: stats.current.score + gain,
    };
    setScore(stats.current.score);
    setCombo(nextCombo);
    setFeedback(nextCombo >= 4 ? '千人同心，節奏一致' : '同步完成');
    navigator.vibrate?.(16);
    setStep((value) => value + 1);
  };

  return (
    <main className="screen-panel themed-stage">
      <header className="compact-game-header">
        <div>
          <span className="eyebrow">第一關 · 詠春千人匯演</span>
          <h2>千人同步演練</h2>
          <p>跟隨領拳口令，直接點按亮起的演武位置。</p>
        </div>
        <strong>{score.toLocaleString()}</strong>
      </header>

      <div className="stage-progress">
        <span style={{ width: `${(step / THOUSAND_MOVES.length) * 100}%` }} />
      </div>

      <section className="thousand-arena">
        <div className="formation-lines" />
        <AnimatePresence mode="wait">
          {current && (
            <motion.div
              className="move-callout"
              key={step}
              initial={{ opacity: 0, y: -8 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <small>領拳口令</small>
              <strong>{current.name}</strong>
              <span>{current.cue}</span>
            </motion.div>
          )}
        </AnimatePresence>

        <div className="performer-grid">
          {Array.from({ length: 12 }, (_, index) => {
            const position = index + 1;
            const active = current?.position === position;
            return (
              <motion.button
                className={`performer ${active ? 'is-active' : ''}`}
                key={position}
                type="button"
                onClick={() => synchronise(position)}
                animate={active ? { scale: [1, 1.12, 1] } : { scale: 1 }}
                transition={active ? { repeat: Infinity, duration: 0.8 } : undefined}
                aria-label={active ? `同步${current.name}` : '等候口令'}
              >
                <i />
                <b />
                {active && <span>{current.name}</span>}
              </motion.button>
            );
          })}
        </div>

        <div className="stage-feedback">{feedback}</div>
        <div className="stage-combo">同步 <strong>×{combo}</strong></div>
      </section>
    </main>
  );
}

export default ThousandPerformanceStage;